import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const ExactCleanupRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment--exact-cleanup']}>
    <Route index element={<Index />} />
  </SubRouter>
))
